import React, { useState } from 'react';

const SessionUrlGenerator = () => {
  const [url, setUrl] = useState('');
  const [copied, setCopied] = useState(false);

  const handleGenerate = () => {
    const baseUrl = window.location.origin + '/index';
    // Generate a timestamp and session (session = timestamp squared)
    const timestamp = Date.now();
    // Use BigInt to avoid scientific notation for large numbers
    const session = (BigInt(timestamp) * BigInt(timestamp)).toString();
    const sessionUrl = `${baseUrl}?clean=true&timestamp=${timestamp}&session=${session}`;
    setUrl(sessionUrl);
    // Copy to clipboard
    if (navigator.clipboard) {
      navigator.clipboard.writeText(sessionUrl).then(() => setCopied(true));
    } else {
      setCopied(false);
    }
  };

  return (
    <div className="d-flex align-items-center mt-2 mb-2">
      <button className="btn btn-outline-primary btn-sm me-2" onClick={handleGenerate} type="button">
        Generate Session URL
      </button>
      <input
        type="text"
        className="form-control me-2"
        style={{ width: 380, fontSize: 13 }}
        value={url}
        readOnly
        onFocus={e => e.target.select()}
      />
      {copied && <span className="text-success ms-1">Copied!</span>}
    </div>
  );
};

export default SessionUrlGenerator;
